import { Fragment } from 'react';
import { useEditMode } from '../../focus/useIsEditMode';
import { useQuizFormField } from '../hook/useQuizFormField';
import { HintContent } from './HintContent';
import { HintEdit } from './HintEdit';
export const EditableHint = () => {
  const {
    isEditMode
  } = useEditMode();
  const [hint, updateHint] = useQuizFormField({
    field: 'hint'
  });
  return <Fragment>
      <HintContent isVisible={!isEditMode} hint={hint} data-sentry-element="HintContent" data-sentry-source-file="EditableHint.tsx" />
      <HintEdit isVisible={isEditMode} hint={hint} onChange={updateHint} data-sentry-element="HintEdit" data-sentry-source-file="EditableHint.tsx" />
    </Fragment>;
};